module.exports = __webpack_public_path__ + "img/feature-item-live.076e3edc.svg";